import { ErrorName } from 'src/constants';

import { BaseError } from './BaseError';

export class NotSupportedFileError extends BaseError {
  constructor({ allowed, actual }: { allowed: string[]; actual: string }) {
    super(`Supported file formats are ${allowed.join(', ').trimEnd()}. Received "${actual}" file format.`, {
      name: ErrorName.NotSupportedFile,
    });
  }
}
